function r(n) {
  return n.map((t) => `"${t.tag}" ${t.value}`).join(", ");
}
function s(n) {
  return Object.entries(n).map(([t, i]) => `"${t}" ${i}`).join(", ");
}
function c(n, t, i = 2) {
  return `${n} {
${a(t, i)}
}`;
}
function a(n, t = 0) {
  const i = new Array(t).fill(" ").join("");
  return Object.entries(n).map(([e, o]) => `${i}${e}: ${o};`).join(`
`);
}
function u(n) {
  const t = n.split(",").map((i) => i.trim());
  return { fontFamily: t[0], fallbacks: t.slice(1).join(", ") };
}
export {
  r as axesToFontVariationSettings,
  s as coordinatesToFontVariationSettings,
  c as getCSSBlock,
  a as getFormattedRules,
  u as parseFontStack
};
//# sourceMappingURL=CSS.js.map
